import React from 'react'
import moment from "moment";
import { Component, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "../../../redux/store";

export class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps = (nextProps) => {};

  shouldComponentUpdate = (nextProps) => {
    return false;
  };

  render() {
    const { data, ...rest } = this.props;
    return <_Timer {...this.props} />;
  }
}

export const _Timer = (props) => {
  // 02M : 10S
  const [timer, setTimer] = useState("");

  const start_time1 = useSelector((state) => {
    return state.ticker.call_start_time;
  });

  const show = () => {
    return setTimeout(() => {
      const start_time = store.getState().ticker.call_start_time;

      if (start_time) {
        let duration = moment.duration(moment().diff(start_time));
        let durationInMinsAndSecs = moment.utc(duration.as('milliseconds')).format('mm:ss')

        let s = durationInMinsAndSecs.format("mm:ss");
        const splits = s.split(":");
        let mm = "";
        let ss = "";

        if (props.disableSymbols) {
          if (splits.length === 1) {
            mm += "00";
            ss += splits[0];
          } else {
            mm += splits[0];
            ss += splits[1];
          }
        } else {
          if (splits.length === 1) {
            mm += "00M";
            ss += splits[0] + "S";
          } else {
            mm += splits[0] + "M";
            ss += splits[1] + "S";
          }
        }

        const timeFmt = `${mm}  :  ${ss}`;

        setTimer(timeFmt);
      }

      return show();
    }, 500);
  };

  useEffect(() => {
    let timer = show();
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  return <span>{timer}</span>;
};
